<div [formGroup]="control" class="flex-column">
	<app-input formControlName="customer" label="{{ 'obiect.nume' | translate }}"></app-input>
	<app-input formControlName="phone" label="{{ 'obiect.telefon' | translate }}"></app-input>

	@if (shopService.isPublicShop()) {
		<app-input formControlName="address" label="{{ 'obiect.adresa' | translate }}"></app-input>
		<app-input formControlName="city" label="{{ 'obiect.localitate' | translate }}"></app-input>
		<app-input formControlName="county" label="{{ 'obiect.judet' | translate }}"></app-input>
		<app-input formControlName="email" label="Email"></app-input>
	}

	@if (itemsLength()) {
		<p class="table-title">
			{{
				"dialog.cartBeforeOrder"
					| translate
						: {
								numar: itemsLength(),
								articole: itemsLength() == 1 ? ("obiect.articol" | translate) : ("obiect.articole" | translate),
						  }
			}}
		</p>

		<app-cart-order-items-form formControlName="items" [currency]="shopSettingsService.currency()" />
	}

	<div class="flex-row-reverse-wrap">
		<div class="total-container">
			<div class="total-articles">
				{{ "obiect.numar" | translate }} {{ "obiect.articole" | translate }}
				<div style="float: right">{{ cartService.totalItemsAmount() }}</div>
			</div>
			<hr />
			<div class="total-price">
				{{ "obiect.total" | translate }}
				<div style="float: right">{{ cartService.totalBuyerPrice() }} {{ shopSettingsService.currency() }}</div>
			</div>
		</div>
	</div>

	<div style="padding-top: 15px">
		<mat-checkbox
			[(ngModel)]="agreed"
			[ngModelOptions]="{ standalone: true }"
			color="primary"
			class="rounded-checkbox"
			#agreedControl="ngModel"
			requiredtrue
		>
			{{ "dialog.acord" | translate }}
		</mat-checkbox>
	</div>

	<div style="padding-top: 15px">
		<mat-checkbox
			[(ngModel)]="termsAccepted"
			[ngModelOptions]="{ standalone: true }"
			color="primary"
			class="rounded-checkbox"
			#termsAcceptedControl="ngModel"
			requiredtrue
		>
			{{ "dialog.termeniPrompt" | translate }}
			<span style="color: dodgerblue" (click)="openTermsAndConditions($event)">(link)</span>
		</mat-checkbox>
	</div>

	@let agreedControlHasErrors = agreedControl.invalid && (agreedControl.dirty || agreedControl.touched);
	@let termsAcceptedControlHasErrors =
		termsAcceptedControl.invalid && (termsAcceptedControl.dirty || termsAcceptedControl.touched);
	@if (agreedControlHasErrors || termsAcceptedControlHasErrors) {
		<mat-error>
			<fmx-errors [errors]="{ required: true }" [resolvers]="[conditionsAgreementValidationResolver]"></fmx-errors>
		</mat-error>
	}
</div>
